import { render, staticRenderFns } from "./dynamic_issues_blocks.vue?vue&type=template&id=2ae8f5b9&lang=pug&"
import script from "./dynamic_issues_blocks.vue?vue&type=script&setup=true&lang=js&"
export * from "./dynamic_issues_blocks.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dynamic_issues_blocks.vue?vue&type=style&index=0&id=2ae8f5b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports